export function Condition() {

    let notify: any;
    let cancel: any;

    const lock = new Promise((resolve, reject) => {
        notify = resolve;
        cancel = reject;
    });

    return {
        notify: (value: string) => notify(value),
        cancel: (reason: any) => cancel(reason),
        lock: lock,
    };
}
